import ENV from "config/Env";
import { permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { AppointmentID, LANDING_PAGES } from "models";

const component = "Login";

export type Session = {
  token: string;
  zoho_unameit_asap_jwt: string;
  was_logged_in: boolean;
  expire_at: string;
  appointment_id?: AppointmentID;
  logged_in: boolean;
  landing_page_id: LANDING_PAGES;
};

export const LoginKeys = {
  session: permanentBackendQueryKey<Session>({ component, baseUrl: ENV.authBaseURL, endpoint: "/session/login/xxx" }) // login/xxx is set because we don't know at this point which method is going to be used to login
};
